<footer class="footer-v2">
  <div class="contact-us">
    <h4 data-aos="fade-in">Let us take you further than you’ve ever been.</h4>

    <div class="contact-us--action-container">
      <a
        data-aos="fade-in"
        data-aos-delay="200"
        class="landing-v2-button"
        href="/contact-us"
      >
        <span class="icon">
          <svg
            width="26"
            height="27"
            viewBox="0 0 26 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="0.927659"
              y1="25.8056"
              x2="25.0061"
              y2="1.72716"
              stroke="currentColor"
              stroke-width="2"
            />
            <line
              x1="6.25293"
              y1="1.43408"
              x2="25.7132"
              y2="1.43408"
              stroke="currentColor"
              stroke-width="2"
            />
            <line
              x1="24.7129"
              y1="22.0596"
              x2="24.7129"
              y2="2.43399"
              stroke="currentColor"
              stroke-width="2"
            />
          </svg>
        </span>
        <span> contact us </span>
      </a>
    </div>
  </div>
  <div class="separator"></div>
  <div class="footer-v2--wrapper">
    <div class="footer-v2--logo">
      <svg
        width="174"
        height="32"
        viewBox="0 0 174 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M31.2394 0.5271V29.9425H25.2376V21.1298C25.2376 16.4024 25.3672 11.4343 25.6263 6.22563C24.7008 10.0247 23.7168 13.4549 22.6745 16.5163L18.1593 29.9425H13.1912L8.5478 16.7897C7.3716 13.368 6.39036 9.88233 5.60883 6.34952C5.85659 12.1135 5.98047 16.8125 5.98047 20.4463V29.9425H0V0.5271H8.97925L13.3108 13.3039C14.3118 16.3517 15.1151 19.4609 15.7158 22.6121C16.3566 19.4412 17.1869 16.3115 18.202 13.2399L22.3285 0.5271H31.2394Z"
          fill="#FAF2F2"
        />
        <path
          d="M61.8809 0.5271H74.8585C77.4215 0.5271 79.3866 0.971363 80.7535 1.85989C83.0916 3.36355 84.2592 5.69593 84.2564 8.85704C84.2564 11.0812 83.6341 12.9109 82.3896 14.3463C81.7419 15.1025 80.9192 15.6891 79.9931 16.055C80.5773 16.2132 81.1239 16.4867 81.6008 16.8594C82.0776 17.232 82.4751 17.6964 82.7698 18.225C83.3466 19.2906 83.7026 20.4617 83.8164 21.6681C83.8819 22.0867 84.0086 23.4579 84.1966 25.7818C84.3617 27.8294 84.628 29.1109 84.9954 29.6264L85.2431 29.9596H79.1388C78.9543 29.5381 78.8196 29.0965 78.7372 28.6439C78.649 28.1996 78.5151 26.6205 78.3357 23.9065C78.1591 21.483 77.5326 19.8953 76.4561 19.1435C75.7299 18.6451 74.5751 18.3945 72.9917 18.3916H67.7246V29.9425H61.8809V0.5271ZM67.7246 5.57633V13.6927H73.2779C75.0806 13.6927 76.3493 13.4079 77.0841 12.8383C78.0125 12.1292 78.4752 11.0513 78.4724 9.6046C78.4724 7.87881 77.8444 6.70265 76.5885 6.07612C75.6231 5.69027 74.5854 5.5183 73.547 5.57205L67.7246 5.57633Z"
          fill="#FAF2F2"
        />
        <path
          d="M92.6891 0.5271H86.6445V29.9425H92.6891V0.5271Z"
          fill="#FAF2F2"
        />
        <path
          d="M119.703 0.5271V29.9425H113.654V17.1443H102.291V29.9425H96.2422V0.5271H102.291V11.6978H113.654V0.5271H119.703Z"
          fill="#FDBF13"
        />
        <path
          d="M147.072 0.881592V18.2719C147.072 20.7752 146.856 22.7103 146.423 24.0773C144.965 28.705 141.242 31.0189 135.253 31.0189C132.023 31.0189 129.49 30.3924 127.653 29.1393C125.711 27.8325 124.343 25.8316 123.83 23.5476C123.454 21.7921 123.289 19.9981 123.339 18.2036V0.881592H129.383V18.6051C129.383 20.8492 129.692 22.4569 130.31 23.428C131.253 24.9202 132.94 25.6649 135.372 25.6621C137.65 25.6621 139.217 24.9587 140.071 23.5518C140.703 22.538 141.019 20.8891 141.019 18.6051V0.881592H147.072Z"
          fill="#FDBF13"
        />
        <path
          d="M150.305 0.881592H162.787C165.452 0.881592 167.446 1.24327 168.767 1.96662C169.982 2.61483 170.961 3.62988 171.565 4.86715C172.101 5.92625 172.378 7.09755 172.373 8.28456C172.405 9.87568 171.863 11.4253 170.848 12.6503C170.241 13.3773 169.481 13.9609 168.622 14.359C169.468 14.6432 170.271 15.0444 171.006 15.5508C172.803 16.9434 173.703 18.9754 173.705 21.6466C173.776 23.7763 173.029 25.8521 171.617 27.4477C169.908 29.3558 167.345 30.3098 163.927 30.3098H150.305V0.881592ZM156.349 5.93509V12.8041H161.903C163.187 12.8041 164.132 12.6432 164.739 12.3214C165.878 11.7347 166.448 10.738 166.448 9.33114C166.448 7.9001 165.897 6.90905 164.795 6.36654C164.205 6.08175 163.24 5.93936 161.898 5.93936L156.349 5.93509ZM156.349 17.1869V25.2435H162.496C164.245 25.2435 165.472 24.9786 166.179 24.4489C167.127 23.7398 167.597 22.6633 167.597 21.2152C167.597 19.4894 166.96 18.3132 165.687 17.6867C164.991 17.3535 163.825 17.1869 162.18 17.1869H156.349Z"
          fill="#FDBF13"
        />
        <path
          d="M34.875 30.2969V12.9065C34.875 10.4004 35.0929 8.46529 35.5286 7.10117C36.9867 2.47912 40.7088 0.169518 46.695 0.172366C49.9244 0.172366 52.459 0.797467 54.2987 2.04767C56.246 3.35299 57.6176 5.3562 58.1305 7.64368C58.5062 9.39914 58.6711 11.1931 58.6217 12.9877V30.2969H52.5772V12.5733C52.5772 10.332 52.2682 8.72444 51.6502 7.75048C50.699 6.25821 49.0145 5.5135 46.5967 5.51634C44.3184 5.51634 42.7521 6.21834 41.8978 7.62232C41.2684 8.639 40.9537 10.2893 40.9537 12.5733V30.2969H34.875Z"
          fill="#FAF2F2"
        />
        <path
          d="M53.4442 13.6797H37.5703V18.9382H53.4442V13.6797Z"
          fill="#FAF2F2"
        />
      </svg>
    </div>
    <ul class="footer-v2--sections">
      <li class="section">
        <h6 class="section--title">Solutions</h6>
        <ul class="section--links">
          <li class="link">
            <a href="/solutions/marketplace">Marihub Marketplace</a>
          </li>
          
        </ul>
      </li>
      <li class="section">
        <h6 class="section--title">Company</h6>
        <ul class="section--links">
          <li class="link">
            <a href="/aboutus">About Us</a>
          </li>
          <!-- <li class="link">
            <a href="/about">Leadership</a>
          </li>
          <li class="link">
            <a href="/about">News</a>
          </li> -->
        </ul>
      </li>
      <!-- <li class="section">
        <h6 class="section--title">Resources</h6>
        <ul class="section--links">
          <li class="link">
            <a href="/about">Case Studies</a>
          </li>
          <li class="link">
            <a href="/about">Reports</a>
          </li>
          <li class="link">
            <a href="/about">Articles</a>
          </li>
        </ul>
      </li> -->
      <!-- <li class="section">
        <h6 class="section--title">Get in Touch</h6>
        <ul class="section--links">
          <li class="link">
            <a href="/about">Partner with us</a>
          </li>
          <li class="link">
            <a href="/about">Get Help!</a>
          </li>
          <li class="link">
            <a href="/about">FAQs</a>
          </li>
        </ul>
      </li> -->
    </ul>
    <section class="footer-v2--copyrights">
      <div class="content">
        <span> © Copyright 2024 Marihub </span>

        <ul>
          <li>
            <a href="#">Terms & Conditions</a>
          </li>
          <li>
            <a href="#">Privacy Policy</a>
          </li>
        </ul>
      </div>
      <div class="socials">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.linkedin.com/company/marihub-international/"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.5247 0.254883H1.47094C0.781153 0.254883 0.220703 0.821289 0.220703 1.5166V16.4932C0.220703 17.1885 0.781153 17.7549 1.47094 17.7549H16.5247C17.2145 17.7549 17.7788 17.1885 17.7788 16.4932V1.5166C17.7788 0.821289 17.2145 0.254883 16.5247 0.254883ZM5.52734 15.2549H2.92497V6.90332H5.53126V15.2549H5.52734ZM4.22615 5.7627C3.39136 5.7627 2.71725 5.08691 2.71725 4.25879C2.71725 3.43066 3.39136 2.75488 4.22615 2.75488C5.05703 2.75488 5.73506 3.43066 5.73506 4.25879C5.73506 5.09082 5.06095 5.7627 4.22615 5.7627V5.7627ZM15.2823 15.2549H12.6799V11.1924C12.6799 10.2236 12.6603 8.97754 11.3278 8.97754C9.97174 8.97754 9.76402 10.0322 9.76402 11.1221V15.2549H7.16166V6.90332H9.6582V8.04395H9.69348C10.0423 7.3877 10.8928 6.69629 12.1587 6.69629C14.7924 6.69629 15.2823 8.42676 15.2823 10.6768V15.2549V15.2549Z"
              fill="#FAF2F2"
            />
          </svg>
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.facebook.com/Marihub.net"
        >
          <svg
            width="10"
            height="19"
            viewBox="0 0 10 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.18849 10.3799L9.68841 7.1223H6.56266V5.00836C6.56266 4.11715 6.99931 3.24844 8.39923 3.24844H9.82025V0.474961C9.82025 0.474961 8.53071 0.254883 7.29778 0.254883C4.72364 0.254883 3.04106 1.81512 3.04106 4.63957V7.1223H0.179688V10.3799H3.04106V18.2549H6.56266V10.3799H9.18849Z"
              fill="#FAF2F2"
            />
          </svg>
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://twitter.com/Marihubnet"
        >
          <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.1375 6.59515C17.1489 6.75475 17.1489 6.91438 17.1489 7.07397C17.1489 11.9418 13.4438 17.5508 6.67209 17.5508C4.58584 17.5508 2.64782 16.9465 1.01758 15.8978C1.31399 15.9319 1.59897 15.9433 1.90679 15.9433C3.6282 15.9433 5.21285 15.3619 6.47828 14.3701C4.85945 14.3359 3.50282 13.2757 3.0354 11.8165C3.26342 11.8506 3.49141 11.8734 3.73084 11.8734C4.06143 11.8734 4.39207 11.8278 4.69985 11.7481C3.01263 11.406 1.74716 9.92402 1.74716 8.13419V8.0886C2.23735 8.36221 2.80741 8.53321 3.41158 8.55598C2.41976 7.89476 1.76997 6.76615 1.76997 5.48932C1.76997 4.80532 1.95234 4.17831 2.27157 3.63109C4.08421 5.86553 6.80888 7.32473 9.8641 7.48436C9.80711 7.21076 9.7729 6.92578 9.7729 6.64077C9.7729 4.61151 11.4145 2.9585 13.4552 2.9585C14.5154 2.9585 15.473 3.4031 16.1456 4.12132C16.9778 3.96172 17.7758 3.6539 18.4827 3.2321C18.209 4.08714 17.6276 4.80535 16.8638 5.26133C17.6049 5.18157 18.3231 4.97632 18.9843 4.69134C18.4827 5.42092 17.8557 6.07071 17.1375 6.59515V6.59515Z"
              fill="#FAF2F2"
            />
          </svg>
        </a>
        <!-- <a href="#">
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.00292 4.51953C6.51855 4.51953 4.51464 6.52343 4.51464 9.00781C4.51464 11.4922 6.51855 13.4961 9.00292 13.4961C11.4873 13.4961 13.4912 11.4922 13.4912 9.00781C13.4912 6.52343 11.4873 4.51953 9.00292 4.51953ZM9.00292 11.9258C7.39745 11.9258 6.08495 10.6172 6.08495 9.00781C6.08495 7.39843 7.39355 6.08984 9.00292 6.08984C10.6123 6.08984 11.9209 7.39843 11.9209 9.00781C11.9209 10.6172 10.6084 11.9258 9.00292 11.9258V11.9258ZM14.7217 4.33593C14.7217 4.91797 14.2529 5.38281 13.6748 5.38281C13.0928 5.38281 12.6279 4.91406 12.6279 4.33593C12.6279 3.75781 13.0967 3.28906 13.6748 3.28906C14.2529 3.28906 14.7217 3.75781 14.7217 4.33593ZM17.6943 5.39843C17.6279 3.99609 17.3076 2.7539 16.2803 1.73047C15.2568 0.707031 14.0146 0.386719 12.6123 0.316406C11.167 0.234375 6.83495 0.234375 5.38964 0.316406C3.99121 0.382812 2.74902 0.703125 1.72168 1.72656C0.694336 2.75 0.37793 3.99218 0.307617 5.39453C0.225586 6.83984 0.225586 11.1719 0.307617 12.6172C0.374023 14.0195 0.694336 15.2617 1.72168 16.2851C2.74902 17.3086 3.9873 17.6289 5.38964 17.6992C6.83495 17.7812 11.167 17.7812 12.6123 17.6992C14.0146 17.6328 15.2568 17.3125 16.2803 16.2851C17.3037 15.2617 17.624 14.0195 17.6943 12.6172C17.7763 11.1719 17.7763 6.84375 17.6943 5.39843V5.39843ZM15.8271 14.168C15.5224 14.9336 14.9326 15.5234 14.1631 15.832C13.0107 16.2891 10.2764 16.1836 9.00292 16.1836C7.72948 16.1836 4.99121 16.2851 3.84277 15.832C3.07715 15.5273 2.4873 14.9375 2.17871 14.168C1.72168 13.0156 1.82715 10.2812 1.82715 9.00781C1.82715 7.73437 1.72558 4.99609 2.17871 3.84765C2.4834 3.08203 3.07324 2.49219 3.84277 2.18359C4.99511 1.72656 7.72948 1.83203 9.00292 1.83203C10.2764 1.83203 13.0146 1.73047 14.1631 2.18359C14.9287 2.48828 15.5185 3.07812 15.8271 3.84765C16.2842 5 16.1787 7.73437 16.1787 9.00781C16.1787 10.2812 16.2842 13.0195 15.8271 14.168Z"
              fill="#FAF2F2"
            />
          </svg>
        </a> -->
      </div>
    </section>
  </div>
</footer>

<!-- <div class="footer-spacer"></div> -->
